module.exports = __webpack_public_path__ + "static/img/11areaB_04.49ffd1d.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/11areaB_04.png
// module id = 1093
// module chunks = 1